
import { getPaymentPaymentPayMethod, setPaymentPaymentOnline } from '@/api/receivables';

const paymentMixins = {
  data() {
    return {
      paymentInfoList: [],
      searchPaymentInfoList: [],
      payMethodObj: {
        needCode: '',
        paymentReqId: '',
        paymentNo: '',
      },
      submitLoading: false,
      paymentInfoNewList: [],
      paymentChannelLoading: false,
    };
  },
  methods: {
    // 获取付款方式接口
    async getPaymentPaymentPayMethod(paymentNo, mergePay = '') {
      try {
        this.paymentInfoList = [];
        this.payMethodObj = {
          needCode: '',
          paymentReqId: '',
          paymentNo: '',
        };
        this.paymentChannelLoading = true;
        const res = await getPaymentPaymentPayMethod({
          paymentNo,
          mergePay, // 机构代付合并标识,1 不合并 , 2 合并
        });
        const { needCode, paymentReqId, paymentInfoNew } = res?.data || {};
        // this.paymentInfoList = paymentInfo || [];
        this.paymentInfoNewList = paymentInfoNew || [];
        this.ruleForm.channelCode = this.paymentInfoNewList.length ? 'ybpay' : ''; // 默认显示易宝数据
        this.$nextTick(() => {
          this.$refs.payWaysListRef.channelCodeChange('ybpay');
        });
        this.isSearch = false;
        this.payMethodObj = {
          needCode,
          paymentReqId,
          paymentNo,
        };
      } catch (error) {
        console.log(error);
      } finally {
        this.paymentChannelLoading = false;
      }
    },
    // 付款渠道选择
    channelCodeChange(data) {
      const { paymentChannelNo, paymentChannelName, channelCode, payeeBusinessNo, channelNo } = data;
      this.ruleForm.channelCode = channelCode || '';
      this.ruleForm.paymentChannelNo = paymentChannelNo || '';
      this.ruleForm.paymentChannelName = paymentChannelName || '';
      this.ruleForm.payeeBusinessNo = payeeBusinessNo || '';
      this.ruleForm.channelNo = channelNo || '';
    },
    // 线上支付
    handleOnline(mergePay) {
      const { paymentChannelNo, code, paymentChannelName, channelNo, payeeBusinessNo } = this.ruleForm;
      const { paymentReqId, paymentNo } = this.payMethodObj;
      const params = {
        paymentReqId, // 付款提交Id
        paymentChannelNo, // 付款渠道编号
        paymentChannelName, // 付款渠道名称
        paymentNo, // 付款单号,多个用,分隔
        code, // 验证码
        mergePay, // 机构代付合并标识,1 不合并 , 2 合并
        channelNo,
        payeeBusinessNo,
        transType: 2, // 订单交易类型1=自营2=服务商
      };
      this.submitLoading = true;
      // 付款单列表-发起付款-出款
      setPaymentPaymentOnline(params).then(() => {
        this.$message.success('操作成功！');
        this.handleClose();
        this.$emit('success');
      }).finally(() => {
        this.submitLoading = false;
      });
    },
    paymentChannelChange(data) {
      const { paymentChannelName, paymentChannelNo, channelNo, payeeBusinessNo } = data;
      this.ruleForm.paymentChannelName = paymentChannelName || '';
      this.ruleForm.paymentChannelNo = paymentChannelNo || '';
      this.ruleForm.payeeBusinessNo = payeeBusinessNo || '';
      this.ruleForm.channelNo = channelNo || '';
      this.$refs.ruleForm.validateField('paymentChannelNo');
    },
  },
};

export default paymentMixins;
